import {useBehavioralContext} from "../../../../contexts";
import {useMediaQuery} from "../../../../hooks";

export const useUpperRow = () => {
    // Search bar feature data
    const {
        handleSearchBar
    } = useBehavioralContext();

    // Simple media query used to control the scroll top action
    const isTablet =
        useMediaQuery("(max-width: 768px)");

    // Procedure to handle the search button click action
    const handleSearchButton = () => {
        // Focus the input element
        document.querySelector("#searchbar-input").focus();

        switch (isTablet) {
            case false: {
                handleSearchBar("isOpen", true);

                break;
            }
            case true: {
                // Scrolls to the top of the page before opening the search component
                window.scrollTo(0, 0);

                const timer = setTimeout(() => {
                    handleSearchBar("isOpen", true);

                    clearTimeout(timer);
                }, 600);

                break;
            }
            default: {
                return;
            }
        }
    }

    return {
        handleSearchBar,
        handleSearchButton
    }
}